<template>
<router-view/>
</template>

<script>
export default {
  name: "EventWrapper"
}
</script>

<style scoped>

</style>